import { certifivateLevel, getAuth } from '@/api/common'
import * as types from './types'

const state = {
  certificateLevel: {},
  authInfo: []
}

const mutations = {
  [types.SET_LEVEL_INFO] (state, data) {
    state.certificateLevel = data
  },
  [types.REMOVE_LEVEL_INFO] (state) {
    state.certificateLevel = {}
  },
  [types.SET_AUTH_INFO] (state, data) {
    state.authInfo = data
  }
}

const getters = {
  // 用户是否激活
  isActive (state) {
    return state.certificateLevel.actived
  },
  // 用户等级
  verifiedStatus (state) {
    return state.certificateLevel.verifiedStatus && state.certificateLevel.verifiedStatus.code
  },
  // 是否绑定卡
  signCardFlag (state) {
    return state.certificateLevel.signCardFlag
  },
  // 账户状态
  accountStatus () {
    return state.certificateLevel.accountStatus && state.certificateLevel.accountStatus.code
  },
  // 账户信息
  accountInfo (state) {
    return {
      mobile: state.certificateLevel.mobile,
      account: state.certificateLevel.account,
      email: state.certificateLevel.email
    }
  },
  // 用户状态
  userStatus () {
    return state.certificateLevel.userStatus && state.certificateLevel.userStatus.code
  },
  // 活体验证是否5次
  faceFaliedLimitReached () {
    return state.certificateLevel.faceFaliedLimitReached
  },
  // 个人审核状态
  faceAuditStatus () {
    return state.certificateLevel.faceAuditStatus
  },
  // 用户功能权限
  authInfo () {
    return state.authInfo
  }
}

const actions = {
  // 获取用户等级信息
  async [types.getCertificateLevel] (context) {
    const data = await certifivateLevel()
    context.commit(types.SET_LEVEL_INFO, data)
  },
  // 获取用户权限信息
  async [types.getAuth] (context) {
    const data = await getAuth()
    context.commit(types.SET_AUTH_INFO, data)
  }
}

export default {
  actions,
  state,
  mutations,
  getters
}
